import { createPendingAction } from '../../shared/storage/pendingAction';
import { PENDING_SELF_ENROLL_COURSE_KEY } from '../courses/endpoints';

import { PENDING_INVITE_LINK_TOKEN_KEY } from './endpoints';

/** /invite/:token — claim a seat on an org's shareable invite link. */
const inviteLink = createPendingAction(PENDING_INVITE_LINK_TOKEN_KEY);
export const rememberInviteToken = inviteLink.remember;
export const readInviteToken = inviteLink.read;
export const clearInviteToken = inviteLink.clear;

/** /invite — self-enroll into a single course. Same road, same potholes. */
const selfEnroll = createPendingAction(PENDING_SELF_ENROLL_COURSE_KEY);
export const rememberSelfEnrollSlug = selfEnroll.remember;
export const readSelfEnrollSlug = selfEnroll.read;
export const clearSelfEnrollSlug = selfEnroll.clear;
